<div class="block--content block" id="main-content">
    <div class="block--wrap block" *ngIf="(isEmailChangeSent$ | async) === false">
        <rwidget-alert></rwidget-alert>

        <ridango-ui-back-button (onBack)="back()"
            >{{ 'RELATED_CARD_DETAIL_BACK_LINK' | translate }}
        </ridango-ui-back-button>

        <div class="ticket">
            <rwidget-customer-account-change-email-aside></rwidget-customer-account-change-email-aside>
            <rwidget-customer-account-change-email (onSubmitEmail)="submitEmail($event)">
            </rwidget-customer-account-change-email>
        </div>
    </div>

    <div class="block--wrap block" *ngIf="isEmailChangeSent$ | async">
        <rwidget-email-sent
            [email]="email"
            [title]="'ACCOUNT_EMAIL_CHANGE_VALIDATION_MAIL_SENT'"
            [description]="'ACCOUNT_EMAIL_CHANGE_VALIDATION_MAIL_SENT_DESCRIPTION'"></rwidget-email-sent>
    </div>
</div>
